import {Model, View} from "@lernetz/ts-lib";
import template from "./column-layout.component.html";


export class ColumnLayoutView extends View {
    constructor() {
        super({template});
    }
}

export class ColumnLayout extends Model {
}
